/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const reviewerDtoSchema = z.object({
  name: z.optional(z.string()),
  initials: z.optional(z.string()),
  role: z.optional(z.string()),
  jobTitle: z.string().nullish(),
  decision: z.optional(
    z.enum(["Pending", "Accepted", "Rejected"]).default("Pending"),
  ),
  decidedAt: z.iso.datetime().nullish(),
  comment: z.string().nullish(),
  ratingScore: z.int().nullish(),
  ratingMode: z
    .enum(["Simplified", "Advanced"])
    .default("Simplified")
    .nullish(),
  isCurrentUser: z.optional(z.boolean()),
});
